import SingletonFactory from './singletonFactory';
import socketActionTypes from './socketActionTypes';
import {
  GET_STORE_CHECKS_REQUESTED,
  GET_STORE_CHECKS_SUCCESS,
  UPDATE_STORE_CHECKS,
} from '@reducers/storeChecks';
import {
  GET_STORE_NOTIFICATIONS_REQUESTED,
  GET_STORE_NOTIFICATIONS_SUCCESS,
  UPDATE_STORE_NOTIFICATIONS
} from '@reducers/storeNotifications';
import {
  SET_SOCKET_CONNECTION
} from '@reducers/oauth';
import EventEmitter from '@utility/eventSubscribers';
import store from '../store';
import { flowType } from '../utility/userInfo';

export const connect = (props) => {
  const options = {
    reconnectionDelay: 500,
    reconnectionAttempts: 3
  };
  const connectCall = (args) => {
    if (window.ReactNativeWebView) {
      EventEmitter.syncStatus(socketActionTypes.SYNC_STATUS_CONNECTED);
    }
    store.dispatch({
      type: SET_SOCKET_CONNECTION,
      payload: true
    });
    args.connectCallback(args);
  };

  const disconnectCall = (args) => {
    if (window.ReactNativeWebView) {
      EventEmitter.syncStatus(socketActionTypes.SYNC_STATUS_DISCONNECTED);
    }
    store.dispatch({
      type: SET_SOCKET_CONNECTION,
      payload: false
    });
    args.disconnectCallback(args);
  };
  SingletonFactory.getInstance(
    props.url,
    (args) => connectCall({ ...args, connectCallback: props.connectCallback }),
    (args) => disconnectCall({ ...args, disconnectCallback: props.disconnectCallback }),
    props.connectionOptions || options,
    props.apiKey,
    props.deviceExternalId,
    props.storeId,
    props.deviceTypeId,
    props.logCapiClientHealthInfo,
    (data) => props.subscriber(data)
  );
};

export const authenticate = ({ headers, id }) => {
  SingletonFactory.getInstance().sendMessageUncompressed(
    socketActionTypes.AUTHENTICATE,
    id,
    headers,
    (e) => {
      if (e) {
        console.warn('socket reconnection check failed at authentication', e);
      } else {
        console.warn('socket authenticate successful', e);
      }
    }
  );
};

export const getStoreMenu = () => {
  SingletonFactory.getInstance().sendMessage('getStoreMenu', JSON.parse(window.sessionStorage.getItem('auth')).id, (data, ...args) => {
  });
};

export const getStoreChecks = (id) => {
  if (window.ReactNativeWebView) EventEmitter.syncStatus(socketActionTypes.SYNC_STATUS_DISCONNECTED);
  return new Promise((resolve, eject) => {
    store.dispatch({
      type: GET_STORE_CHECKS_REQUESTED,
      resolve,
      eject
    });
  }).then(() => {
    SingletonFactory.getInstance().sendMessage(
      socketActionTypes.GET_STORE_CHECKS,
      id,
      (...response) => {
        if (window.ReactNativeWebView) {
          EventEmitter.syncStatus(socketActionTypes.SYNC_STATUS_CONNECTED);
        }
        store.dispatch({
          type: GET_STORE_CHECKS_SUCCESS,
          payload: response[1]
        });
      }
    );
  });
};

export const getStoreCheck = (id) => {
  return new Promise((resolve) => {
    SingletonFactory.getInstance().sendMessage(
      socketActionTypes.GET_STORE_CHECKS,
      id,
      (...response) => {
        resolve(response[1]);
      }
    );
  });
};

export const getStoreNotifications = (id) => {
  return new Promise((resolve, eject) => {
    store.dispatch({
      type: GET_STORE_NOTIFICATIONS_REQUESTED,
      resolve,
      eject
    });
  }).then(() => {
    SingletonFactory.getInstance().sendMessage(
      socketActionTypes.GET_STORE_NOTIFICATIONS,
      id,
      (...response) => {
        if (window.ReactNativeWebView) {
          // EventEmitter.syncLogsData(socketActionTypes.INFO, 'Get store notifications', response && response[1] && response[1].length);
        }
        store.dispatch({
          type: GET_STORE_NOTIFICATIONS_SUCCESS,
          payload: response[1]
        });
      }
    );
  });
};

export const subscribeToStoreChecks = (id) => {
  if (window.ReactNativeWebView) {
    // EventEmitter.syncLogsData(socketActionTypes.INFO, 'Invoking subscribe store checks');
  }
  SingletonFactory.getInstance().redisSubscribe(
    socketActionTypes.SUBSCRIBE_TO_STORE_CHECKS,
    id,
    (...response) => {
    },
    (response) => {
      if (window.ReactNativeWebView) {
        // EventEmitter.syncLogsData(socketActionTypes.INFO, 'Subscribed to store checks');
      }
      if (flowType() === 'kiosk') {
        const event = new CustomEvent('getUpdatedCheck', {
          detail: response.value,
          bubbles: true,
          cancelable: true,
          composed: false,
        });
        document.dispatchEvent(event);
      }
      store.dispatch({
        type: UPDATE_STORE_CHECKS,
        payload: response.value
      });
    }
  );
};

export const subscribeToStoreNotifications = (id) => {
  if (window.ReactNativeWebView) {
  }
  SingletonFactory.getInstance().redisSubscribe(
    socketActionTypes.SUBSCRIBE_TO_STORE_NOTIFICATIONS,
    id,
    (...response) => {
    },
    (response) => {
      if (response && response.value && response.value.id && response.value.notificationTypeId === 19 && window.ReactNativeWebView) {
        EventEmitter.mdmPolicy(socketActionTypes.MDM_POLICY);
      }
      if (window.ReactNativeWebView) {
      }
      store.dispatch({
        type: UPDATE_STORE_NOTIFICATIONS,
        payload: response.value
      });
    }
  );
};

export const unSubscribeToStoreNotification = () => {
  if (window.ReactNativeWebView) {
  }
  SingletonFactory.getInstance().unsubscribe(socketActionTypes.SUBSCRIBE_TO_STORE_NOTIFICATIONS);
};

export const unSubscribeToStoreChecks = () => {
  if (window.ReactNativeWebView) {
  }
  SingletonFactory.getInstance().unsubscribe(socketActionTypes.SUBSCRIBE_TO_STORE_CHECKS);
};

export const disconnect = () => {
  SingletonFactory.getInstance().disconnect();
};
